export default {
  'to-manager:btn': 'Жеке Банкке қайту'
}
